import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListSearchNotificationPayload } from '@app-store/slices/notifications/listSearch'

interface TaskAction extends Action {
    payload: IListSearchNotificationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.notification.listSearch

function* listSearchNotificaionSagaTask({ payload }) {
    const params = yield getParams(payload)
    try {
        const response = yield axios.get(`/notifications`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listSearchNotificaionSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listSearchNotificaionSagaTask)
}

export default listSearchNotificaionSaga
